import { render, staticRenderFns } from "./JobUpdated.vue?vue&type=template&id=8b8f33c4&scoped=true"
import script from "./JobUpdated.vue?vue&type=script&lang=js"
export * from "./JobUpdated.vue?vue&type=script&lang=js"
import style0 from "./JobUpdated.vue?vue&type=style&index=0&id=8b8f33c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8f33c4",
  null
  
)

export default component.exports